export default "__VITE_ASSET__QbcX9kyj__"